import React from "react";
import PropTypes from "prop-types";
import {makeStyles, Grid, Typography, Box} from "@material-ui/core";
import {useLocation} from "../../../common/common";
import {RESORTS} from "../../../common/routes";
import {CustomButton} from "@hapinest/theme";

const useStyles = makeStyles(theme => ({
    textCenter: {
        textAlign: "center"
    },
    topImage: {
        marginTop: theme.spacing(4),
        [theme.breakpoints.up("sm")]: {
            marginTop: theme.spacing(19),
        },
    },
    marginBottom2: {
        marginBottom: theme.spacing(2)
    }
}));

const NoResults = ({imgTopSrc, heading, subheading, actionLabel}) => {
    const classes = useStyles();
    const {navigate} = useLocation();

    const handleAction = () => {
        navigate(RESORTS, {}, false, false);
    };

    return (
        <Grid
            container
            direction="column"
            justify="center"
            className={classes.textCenter}
        >
            <Grid
                item
            >
                <Box>
                    <img
                        alt="reservation"
                        src={imgTopSrc}
                        className={classes.topImage}
                    />
                </Box>
            </Grid>

            <Grid
                item
            >
                <Box
                    pt={3}
                >
                    <Typography
                        variant={"h2"}
                    >
                        {heading}
                    </Typography>

                </Box>
            </Grid>

            <Grid
                item
            >
                <Box
                    pt={3}
                >
                    <Typography
                        variant={"body1"}
                    >
                        {subheading}
                    </Typography>
                </Box>
            </Grid>

            <Grid
                item
            >
                <Box
                    pt={3}
                >
                    <CustomButton
                        variant={"contained"}
                        disableElevation
                        onClick={handleAction}
                    >
                        {actionLabel}
                    </CustomButton>
                </Box>
            </Grid>
        </Grid>
    );
};

NoResults.propTypes = {
    imgTopSrc: PropTypes.string,
    heading: PropTypes.string,
    subheading: PropTypes.string,
    actionLabel: PropTypes.string
};

export default NoResults;
